import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_TINCHAP } from "actions/TinChap/actionTypes";
import { getListTinChapSuccess, getListTinChapFailure } from "actions/TinChap";
import TinChapApi from "service/tinChapApi";
import { pushNotification } from "utils/notifications";

function* getListTinChap(action) {
  try {
    const response = yield call(TinChapApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListTinChapSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListTinChapFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListTinChapFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_TINCHAP, getListTinChap);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
